import { useEffect, useState } from "react";
import { ExternalLink } from "lucide-react";
import { api } from "@/components/Common";
import { Page, PageHeader, Loading } from "@/components/Common";

const COVER_BG = "https://static.prod-images.emergentagent.com/jobs/ad4a25d6-f9f8-4ebb-8af4-ecf657d6bc8a/images/bd6dcf7d5641817bedd24fee2f44958d4377326fff48fda0c7d5273444aa0400.jpeg";

const JournalCover = ({ j, i }) => (
  <a
    href={j.url}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={`journal-card-${j.slug}`}
    className="group relative block aspect-[3/4] rounded-xl overflow-hidden border border-[#d4af37]/50 shadow-[0_6px_24px_rgba(42,21,8,0.12)] transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_16px_40px_rgba(42,21,8,0.22)] hover:border-[#d4af37]"
    style={{ backgroundImage: `url(${COVER_BG})`, backgroundSize: "cover", backgroundPosition: "center" }}
  >
    <div className="absolute inset-0 bg-gradient-to-b from-[#2a1508]/10 via-[#2a1508]/20 to-[#2a1508]/75 transition-opacity duration-300 group-hover:from-[#2a1508]/5 group-hover:to-[#2a1508]/70" />
    <div className="absolute inset-3 border border-[#d4af37]/50 rounded-lg pointer-events-none" />
    <div className="relative h-full flex flex-col items-center justify-between text-center p-5">
      <span className="font-latin text-[0.6rem] tracking-[0.35em] text-[#7a5230] uppercase">Urdu Magazine</span>
      <div className="flex-1 flex flex-col items-center justify-center">
        <h3 className="text-3xl sm:text-4xl font-bold text-[#2a1508] leading-[2] drop-shadow-sm">{j.title}</h3>
        {j.era && <p className="mt-1 text-base text-[#4a2b16] leading-[2]">{j.era}</p>}
      </div>
      <div className="w-full">
        <span className="inline-block text-xs sm:text-sm px-3 py-1 rounded-full bg-[#2a1508]/85 text-[#e8dfcc] leading-[2]">{j.freq}</span>
        <p className="mt-3 text-[#e8dfcc] text-sm leading-[2] opacity-0 group-hover:opacity-100 transition-opacity duration-300 inline-flex items-center gap-1">
          Rekhta پر پڑھیں <ExternalLink size={12} />
        </p>
      </div>
    </div>
  </a>
);

export default function JournalsPage() {
  const [journals, setJournals] = useState(null);
  useEffect(() => {
    api.get("/journals").then((r) => setJournals(r.data)).catch(() => setJournals([]));
  }, []);

  return (
    <Page>
      <PageHeader title="اردو رسائل و جرائد" subtitle="قدیم و جدید اردو رسائل و جرائد — Rekhta آرکائیو سے منسلک" crumbs={[{ label: "اردو رسائل و جرائد" }]} />
      {!journals ? (
        <Loading />
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6" data-testid="journals-grid">
          {journals.map((j, i) => (
            <JournalCover key={j.slug} j={j} i={i} />
          ))}
        </div>
      )}
    </Page>
  );
}
